module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-Bold.36b5da03.ttf";